<div class="dashboard-card-item">
  <div class="dashboard-card-item-title">{{ 'home.historic.title' | translate }}</div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.historic.totalGroups' | translate }}</div>
    <div class="dashboard-data-info">{{ totalGroups }}</div>
  </div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.historic.ratioFinished' | translate }}</div>
    <div class="dashboard-data-info">{{ ratioFinished }}</div>
  </div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.historic.ratioRecommendation' | translate }}</div>
    <div class="dashboard-data-info">{{ ratioRecommendation }}</div>
  </div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.historic.ratioApplication' | translate }}</div>
    <div class="dashboard-data-info">{{ ratioApplication }}</div>
  </div>
</div>
